import { Link } from "react-router";

export default function WelcomeLoginProfile() {
  return (
    <>
      <span className="mb-4 text-2xl text-slate-600">
        Vous pouvez désormais finir votre inscription.
      </span>

      <div className="w-full py-5 text-slate-600">
        En cliquant sur "Commencer", vous acceptez les{" "}
        <Link className="inline text-slate-600" to="/cgus">
          Conditions Générales d'Utilisation
        </Link>{" "}
        et la{" "}
        <Link className="text-slate-600" to="/confidentialité">
          Politique de Confidentialité
        </Link>
        .
      </div>
      <div className="flex w-full items-center justify-center py-5">
        <button
          className="mx-auto shrink-0 rounded-lg border-none bg-primary px-5 py-1 text-white disabled:pointer-events-none disabled:opacity-30"
          type="submit"
          form="onboarding-form"
        >
          Commencer
        </button>
      </div>
    </>
  );
}
